import VehicleComparisonWithDataView from "./VehicleComparisonWithDataView";

export default VehicleComparisonWithDataView;
